import discoFlotacao from '../assets/images/products/disco-flotacao.png';
import redutor from '../assets/images/products/redutor.png';
import cabecasPolimento from '../assets/images/products/cabeca-polidora.png';
import arvorePolimento from '../assets/images/products/arvore-de-polimento.png';
import mancalRetifica from '../assets/images/products/mancal-de-retifica.png';

export type TProduct = {
	name: string;
	description: string;
	characteristics?: string[];
	behavior?: string[];
	types?: string[];
	image?: string;
}

export const products: TProduct[] = [
	{
		name: 'Disco de Flotação',
		image: discoFlotacao,
		description: `O disco de flotação é um acessório utilizado em alisadoras de concreto para nivelar e alisar o piso.`,
		characteristics: [
			'Feito em metal de alta resistência.',
			'É balanceado para evitar desgaste desigual.',
			'Tem bordas arredondadas para evitar arraste do material.',
		],
		behavior: [
			'É feito de metal de alta resistência.',
			'É balanceado para evitar desgaste desigual.',
			'Tem bordas arredondadas para evitar arraste do material.',
		],
	},
	{
		name: 'Redutores',
		image: redutor,
		description: `Os redutores são dispositivos mecânicos projetados para reduzir a velocidade de rotação transmitida de um motor ou sistema de acionamento, ajustando-a para os níveis exigidos por uma aplicação específica. Eles também são responsáveis por aumentar o torque, garantindo maior força disponível no eixo de saída, o que os torna essenciais em diversos equipamentos industriais e máquinas.`,
		types: [
			'Redutores de Engrenagens Helicoidais: Ideais para aplicações que requerem operação silenciosa e contínua.',
			'Redutores Cônicos: Utilizados em transmissões que necessitam de mudanças de direção do eixo.',
			'Redutores Planetários: Compactos e eficientes, frequentemente usados em aplicações de alta precisão e torque elevado.',
			'Redutores de Parafuso Sem-Fim: Comumente utilizados em aplicações que demandam alta redução de velocidade em espaços reduzidos.',
		],
	},
	{
		name: 'Cabeças de Polimento',
		image: cabecasPolimento,
		description: `As cabeças de polimento utilizadas no processo de acabamento de porcelanatos desempenham um papel crucial na obtenção de superfícies de alta qualidade. Como instrumentos de precisão, é essencial que estejam devidamente ajustadas para garantir um desempenho eficiente e resultados consistentes no polimento.`,
		characteristics: [
			'Precisão de operação: Assegura um polimento uniforme e consistente nas peças cerâmicas, garantindo alta qualidade de acabamento.',
			'Resistência ao desgaste: Feitas com materiais duráveis para suportar o contato constante com superfícies abrasivas sem perder eficiência.',
			'Capacidade de ajuste: Permite regular a pressão e a posição para diferentes formatos e texturas de cerâmicas.',
			'Suporte a altas velocidades: Funcionam em operações de alta rotação sem causar desalinhamento ou vibrações excessivas.',
			'Compatibilidade com diversos abrasivos: Adaptam-se a diferentes tipos de discos de polimento ou lixas, conforme o nível de acabamento desejado.',
			'Facilidade de manutenção: Projetadas para trocas rápidas de ferramentas e para manutenção simples, reduzindo o tempo de inatividade da linha de produção.',
			'Absorção de vibrações: Minimizam as vibrações transmitidas para a peça, garantindo um acabamento mais fino e uniforme.',
		],
	},
	{
		name: 'Árvore de Polimento',
		image: arvorePolimento,
		description: `As árvores da polidora são dispositivos que sustentam as cabeças de polimento para realizar o acabamento em porcelanatos. Elas são compostas por um corpo fixo, base para fixação da cabeça polidora, canote móvel e sistema pneumático (sobe e desce).`,
		characteristics: [
			'Resistencia mecânica: Suporta o esforço constante sem deformações.',
			'Precisão: Garante alinhamento correto no conjunto de polimento.',
			'Durabilidade: Fabricado com componentes de primeira linha para garantir maior tempo de operação.',
		],
	},
	{
		name: 'Mancal de Retífica',
		image: mancalRetifica,
		description: `O mancal de retífica cerâmica é um componente fundamental utilizado em máquinas de retífica para apoiar, guiar e estabilizar o eixo ou a ferramenta de corte durante o processo de usinagem e acabamento de peças cerâmicas. Ele desempenha um papel crucial na precisão e eficiência do processo, garantindo um movimento suave e minimizando vibrações ou desalinhamentos.`,
		characteristics: [
			'Alta precisão: Os mancais de retífica em cerâmicas precisam garantir alta precisão para manter o eixo da máquina em alinhamento perfeito, minimizando vibrações e garantindo uma retificação uniforme e de qualidade.',
			'Resistência ao desgaste: Dado o ambiente abrasivo em que operam, os mancais usados em retíficas de cerâmicas devem ser altamente resistentes ao desgaste. Eles frequentemente utilizam materiais como aço endurecido ou cerâmica técnica.',
			'Capacidade de suportar altas temperaturas: Durante o processo de retificação, as cerâmicas geram calor devido ao atrito. Por isso, os mancais precisam ser capazes de operar em temperaturas elevadas sem perder suas propriedades mecânicas.',
			'Lubrificação: Muitos desses mancais exigem um sistema de lubrificação eficiente para reduzir o atrito e prolongar a vida útil do componente, além de evitar superaquecimento.',
			'Absorção de impacto: Mancais usados em retíficas devem ter boa capacidade de absorver impactos e choques gerados durante o processo de retificação, mantendo a estabilidade e prolongando a vida útil do maquinário.',
		],
	}
];